import React from 'react'
import { Card, FlexView, Icon } from 'components/common'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import infoTranspote from '../../assets/images/infoTransporte.png'
import infoFiscal from '../../assets/images/infoFiscal.png'
import outrasInfos from '../../assets/images/outrasInfos.png'
import moment from 'moment/moment'

const Name = styled.div`
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
`

const Value = styled.div`
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    display: flex;
    align-items:center;
    column-gap: 5px;
`

const Title = styled.div`
    color: #797979;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
`

const InformationCards = (data) => {
    const { t } = useTranslation()
    const transporte = data.data.transportInformation
    const keysTransporte = Object.keys(transporte).filter((item) => item !== 'shippingCompany')

    const fiscal = data.data.taxInformation
    const keysFiscal = Object.keys(fiscal)

    const outras = data.data.otherInformation
    const keysOutras = Object.keys(outras)
    let NF = 0
    data.data.attachs.forEach((item) => {
        if (item.name.includes('NF_') || item.type === 'NOTA FISCAL') {
            NF++
        } return NF
    })

    return <FlexView flexDirection="row" width='100%' style={{ columnGap: "16px" }} padding="5px 0px">
        <Card width='100%' margin="0">
            <FlexView width='100%'>
                <FlexView width="100%" flexDirection="row" style={{ columnGap: '16px', marginBottom: '10px' }} alignItems="center">
                    <img src={infoTranspote} style={{ width: "52px" }} alt='Informação de transporte'></img>
                    <Title>{t(`transport.transportInformation`)}</Title>
                </FlexView>
                {keysTransporte.map((item, i) => (
                    <FlexView key={i} width="100%" flexDirection="row" style={{ alignItems: "center", justifyContent: "space-between", borderBottom: '1px solid lightGray', padding: '5px 0px', minHeight: '22px' }}>
                        <Name>{t(`transport.${item}`)}:</Name>
                        {item === 'scheduledDate' ?
                            <Value>{moment(transporte['scheduledDate']).utc().format('L')}</Value>
                            : <Value>{transporte[item]}</Value>

                        }
                    </FlexView>
                ))}
            </FlexView>
        </Card>
        <Card width='100%' margin="0">
            <FlexView width='100%'>
                <FlexView width="100%" flexDirection="row" style={{ columnGap: '16px', marginBottom: '10px' }} alignItems="center">
                    <img src={infoFiscal} style={{ width: "45px" }} alt='Informação de transporte'></img>
                    <Title>{t(`transport.taxInformation`)}</Title>
                </FlexView>
                {keysFiscal.map((item, i) => (
                    <FlexView key={i} width="100%" flexDirection="row" style={{ alignItems: "center", justifyContent: "space-between", borderBottom: '1px solid lightGray', padding: '5px 0px', minHeight: '22px' }}>
                        <Name>{t(`transport.${item}`)}:</Name>
                        {fiscal[item] === "" || fiscal[item] === "-" || fiscal[item] === '0' ?
                            <Value><Icon name="warning" color="warning" width="20px" height="20px" />{t(`transport.notInformed`)}</Value>
                            : item === 'vallInvoice' ? <Value>{NF}</Value> :
                                <Value>{fiscal[item]}</Value>}

                    </FlexView>
                ))}
            </FlexView>
        </Card>
        <Card width='100%' margin="0">
            <FlexView width='100%'> <FlexView width="100%" flexDirection="row" style={{ columnGap: '16px', marginBottom: '10px' }} alignItems="center">
                <img src={outrasInfos} style={{ width: "45px" }} alt='Informação de transporte'></img>
                <Title>{t(`transport.otherInformation`)}</Title>
            </FlexView>
                {keysOutras.map((item, i) => (
                    item !== 'icms' && item !== "insurance" ?
                        <FlexView key={i} width="100%" flexDirection="row" style={{ alignItems: "center", justifyContent: "space-between", borderBottom: '1px solid lightGray', padding: '5px 0px', minHeight: '22px' }}>
                            {item === 'icms' || item === 'icmsPercentage' ?
                                <>
                                    <Name>{t('transport.icms')} ({outras['icmsPercentage']}%):</Name>
                                    <Value>R${Number(outras['icms']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Value>
                                </>
                                : item === 'insurance' || item === 'insurancePercentage' ?
                                    <>
                                        <Name>{t('transport.insurancePrice')} ({outras['insurancePercentage']}%):</Name>
                                        <Value>R${Number(outras['insurance']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Value>
                                    </>
                                    :
                                    <>
                                        <Name>{t(`transport.${item}`)}:</Name>
                                        <Value>R${Number(outras[item]).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Value>
                                    </>
                            }
                        </FlexView>
                        : null
                ))}
            </FlexView>
        </Card>
    </FlexView>
}

export default InformationCards